import "./Products.css";
import React, {useContext} from "react";
import {useNavigate} from "react-router-dom";
import ClienteDirectoContext from "../../../context/ClienteDirectoContext";
import {filterActiveLandingProducts, getProductsNavClass} from "../../../utils/landingProducts";
import {LANDING_PRODUCTS_CATALOG} from "./Products.config";

const Products = () => {
    const {activeProducts} = useContext(ClienteDirectoContext);

    let navigate = useNavigate();
    const finalProducts = filterActiveLandingProducts(LANDING_PRODUCTS_CATALOG, activeProducts);

    return (
        <section className='products'>
            <h1>Productos para cotizar</h1>
            {finalProducts.length === 0 ? (
                <p className="products__empty">
                    Por ahora no hay productos disponibles para cotizar.
                </p>
            ) : (
                <nav className={getProductsNavClass(finalProducts.length)}>
                    {finalProducts.map((product) => {
                        const Icon = product.icon;
                        return (
                            <button
                                key={product.id}
                                type="button"
                                onClick={() => {
                                    navigate("cotizar" + product.path);
                                    window.scrollTo({top: 0, behavior: "smooth"});
                                }}
                            >
                                <div className='iconContainer'>
                                    <Icon className='icon'/>
                                </div>
                                <p>{product.name}</p>
                            </button>
                        );
                    })}
                </nav>
            )}
        </section>
    )
};

export default Products;
